export enum TrophyLevel {
  BASIC,
  PROFI,
  CHAMPION,
  SENSEI
}
